export default __webpack_public_path__ + "static/media/4-data-display-7-avatar-default@2x.50cc0d00.svg";